<template>
    <div class="page-wrapper">
      <div class="page-content">
        <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
          <div class="breadcrumb-title pe-3">Home</div>
          <div class="ps-3">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item">
                  <router-link to="/home"><i class="bx bx-home-alt"></i></router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Update Hero Section
                </li>
              </ol>
            </nav>
          </div>
          <div class="ms-auto"></div>
        </div>
        <hr />
        <form>
          <div class="card">
            <div class="card-body p-4">
              <h5 class="card-title">Update Slider</h5>
              <hr />
              <div class="form-body mt-4">
                <div class="row">
                  <div class="col-lg-8">
                    <div class="border border-3 p-4 rounded mb-3">
                      <div class="mb-3">
                        <label for="inputProductTitle" class="form-label">Title</label>
                        <input type="text" class="form-control" id="inputProductTitle" placeholder="Slider title"
                          v-model="singleProject.title" />
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Description</label>
                        <ckeditor :editor="editor" v-model="singleProject.description" :config="editorConfig"></ckeditor>
                      </div>
                      <div class="mb-3">
                        <label for="inputProductTitle" class="form-label">Button Text:</label>
                        <input type="text" class="form-control" id="inputProductTitle"
                          v-model="singleProject.buttonText" />
                      </div>
                      <div class="mb-3">
                        <label for="inputProductTitle" class="form-label">Button Link:</label>
                        <input type="text" class="form-control" id="inputProductTitle"
                          v-model="singleProject.buttonLink" />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8">
                      <div class="border border-3 p-4 rounded">
                        <div class="mb-3">
                          <label class="form-label">Image: <strong>[Preferred Image Size: 1440X2114, Max Upload Limit:
                              1MB]</strong></label>
                          <input class="form-control mb-2" type="file" name="image" id="image"
                            ref="image" aria-describedby="imageHelp" accept="image/*" @change="uploadSliderImage" />
                          <img v-if="previewImage" :src="previewImage" height="80"/>
                          <img v-else :src="singleProject.image" height="80" />
                        </div>
                        <div class="mb-3">
                          <label class="form-label">Button Icon: <strong>[Preferred Image Size: 1440X2114, Max Upload Limit:
                              1MB]</strong></label>
                          <input class="form-control mb-2" type="file" name="buttonIcon" id="buttonIcon"
                            ref="buttonIcon" aria-describedby="imageHelp" accept="image/*" @change="uploadButtonIcon" />
                          <img v-if="previewIcon" :src="previewIcon" height="80"/>
                          <img v-else :src="singleProject.buttonIcon" height="80" />
                        </div>
                        
                        <div>
                          <div class="d-grid">
                            <button type="button" @click="updateSlider" class="btn btn-primary">
                              Update Slider
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                <!--end row-->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script src='../js/update-slider.js'></script>